import AsyncStorage from '@react-native-async-storage/async-storage';

import type { ProfileStep } from './profile-nudge';

// Device-local, presentation-only: which nudge step the user dismissed.
const STORAGE_KEY = '@nearkin/profile-nudge-dismissed-step';

export async function getDismissedStep(): Promise<string | undefined> {
  return (await AsyncStorage.getItem(STORAGE_KEY)) ?? undefined;
}

export async function dismissStep(step: ProfileStep): Promise<void> {
  await AsyncStorage.setItem(STORAGE_KEY, step);
}
